import { ChangeEvent } from 'react';
import './css/toggle.css';

interface IToggleProps {
  value: boolean;
  handleChange: (e: boolean) => void;
}

export const Toggle = ({ value, handleChange }: IToggleProps) => {
  return (
    <label className="toggle-switch">
      <input type="checkbox" checked={value} onChange={(e) => handleChange(e.target.checked)} />
      <span className="toggle-switch__slider round"></span>
    </label>
  );
};
